import { weixinReady } from '../outsdk/weixin'
import { alipayMpReady } from '../outsdk/alipaymp'
import query from '../util/query'

const params = Object.assign({}, query.query(), query.hashQuery())

function getPayPageUrl (opts) {
  if (params.from === 'xwebapp') {
    // 滴滴出行小程序
    let ext = (opts.ext && opts.ext.xwebapp) || {}
    let data = Object.assign({}, opts.pay, ext)
    return query.buildMp('/pay/pages/index', data)
  } else {
    // 出行广场小程序  其他的小程序暂时 不支持（不想兼容）
    let ext = (opts.ext && opts.ext.market) || {}
    let data = Object.assign({}, opts.pay, ext)
    return query.buildMp('/pages/paymentPage/index', data)
  }
}

export function openWxPayPage (opts) {
  weixinReady(sdk => {
    if (window.wx && window.wx.miniProgram) {
      window.wx.miniProgram.navigateTo({
        url: getPayPageUrl(opts),
        success: () => {
          opts.success && opts.success()
        },
        fail: (err) => {
          opts.fail && opts.fail(err)
        }
      })
    } else {
      opts.fail && opts.fail({
        errno: -1,
        errmsg: 'sdk加载异常'
      })
    }
  })
}

export function openAlipayPayPage (opts) {
  alipayMpReady(sdk => {
    if (window.my && window.my.navigateTo) {
      window.my.navigateTo({
        url: getPayPageUrl(opts),
        success: () => {
          opts.success && opts.success()
        },
        fail: (err) => {
          opts.fail && opts.fail(err)
        }
      })
    } else {
      opts.fail && opts.fail({
        errno: -1,
        errmsg: 'sdk加载异常'
      })
    }
  })
}
